import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "contents-container" }
const _hoisted_4 = {
  key: 1,
  class: "mt-5 no-items-container"
}
const _hoisted_5 = { class: "text-h5 mt-2 title-container" }
const _hoisted_6 = { class: "font-weight-medium" }

import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import '@/styles/global.scss'
import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { firestore as db, storage } from '@/main'
import { CommonBoardItem } from '@/types/CommonBoardItem'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { collection, getDocs, query, orderBy, Query, deleteDoc, doc } from 'firebase/firestore'
import { ref as storageRef, deleteObject } from 'firebase/storage'
import { onMounted, ref, watch } from 'vue'
import { RouteLocationNormalizedLoadedGeneric, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'
import BoardItemModal from '@/components/board/BoardItemModal.vue'
import CommonProgress from '@/components/common/CommonProgress.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardView',
  setup(__props) {

const router = useRouter()
const itemsList = ref<CommonBoardItem[]>([])
const filteredList = ref<CommonBoardItem[]>([])
const isLoading = ref(true)
const searchText = ref('')
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())
const selectedItem = ref<CommonBoardItem | null>(null)
const showWindow = ref(false)

let itemsQuery: Query | undefined

function isExpandedAll () {
  return filteredList.value.every(item => item.showContents)
}

function expandAll () {
  const expand = !isExpandedAll()
  filteredList.value.forEach(item => {
    item.showContents = expand
  })
}

function getRouteName (newRoute: RouteLocationNormalizedLoadedGeneric | undefined = undefined) {
  switch (newRoute ? newRoute.path : router.currentRoute.value.path) {
    case '/awards':
      return 'Awards'
    case '/news':
      return 'News'
    case '/gallery':
      return 'Gallery'
    default:
      return 'Awards'
  }
}

function setQuery () {
  switch (router.currentRoute.value.path) {
    case '/awards':
      itemsQuery = query(collection(db, 'Awards'), orderBy('date', 'desc'))
      break
    case '/news':
      itemsQuery = query(collection(db, 'News'), orderBy('date', 'desc'))
      break
    case '/gallery':
      itemsQuery = query(collection(db, 'Gallery'), orderBy('date', 'desc'))
      break
    default:
      itemsQuery = query(collection(db, 'Awards'), orderBy('date', 'desc'))
      break
  }
}

function getItems () {
  setQuery()
  isLoading.value = true
  itemsList.value = []

  if (itemsQuery) {
    getDocs(itemsQuery)
      .then((querySnapshot) => {
        itemsList.value = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as CommonBoardItem),
          id: doc.id,
          contentsDelta: doc.data().contents === '' || doc.data().contents === undefined ? undefined : new Delta(JSON.parse(doc.data().contents || '{}')),
          showContents: false,
          category: getRouteName()
        }))

        filteredList.value = itemsList.value
      })
      .catch((error: Error) => {
        console.log(error.message)
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

function onModifyItem (item: CommonBoardItem) {
  showWindow.value = false
  router.push({
    name: 'modifyPost',
    state: {
      post: {
        id: item.id,
        contents: item.contents,
        title: item.title,
        date: item.date,
        category: getRouteName()
      }
    }
  })
}

function deleteItem (item: CommonBoardItem) {
  if (confirm(`Are you sure you want to delete post ${item.title}?\nThis action cannot be undone.`)) {
    showWindow.value = false
    isLoading.value = true
    deleteDoc(doc(db, getRouteName(), item.id as string))
      .then(() => {
        if (item.image !== '' && item.image !== undefined && item.image !== null) {
          deleteObject(storageRef(storage, `${getRouteName().toLowerCase()}/img/${item.id}.${item.image.split('.').pop()?.split('?')[0]}`))
            .catch((e: Error) => {
              alert(`An error occurred while deleting image.\nPlease try again later.\n(${e.message})`)
            })
            .finally(() => {
              alert('Post deleted successfully.')
              itemsList.value = itemsList.value.filter(i => i.id !== item.id)
              filteredList.value = filteredList.value.filter(i => i.id !== item.id)
              isLoading.value = false
            })
        } else {
          alert('Post deleted successfully.')
          itemsList.value = itemsList.value.filter(i => i.id !== item.id)
          filteredList.value = filteredList.value.filter(i => i.id !== item.id)
          isLoading.value = false
        }
      })
      .catch((e: Error) => {
        alert(`An error occurred while deleting post.\nPlease try again later.\n(${e.message})`)
        isLoading.value = false
      })
  }
}

onMounted(() => {
  getItems()
})

watch(router.currentRoute, () => {
  getItems()
})

watch(searchText, () => {
  if (searchText.value === '') {
    filteredList.value = itemsList.value
  } else {
    filteredList.value = itemsList.value.filter(item => item.title.toLowerCase().includes(searchText.value.toLowerCase()) || (item.contents !== undefined && item.contents.toLowerCase().includes(searchText.value.toLowerCase())))
  }
})

watch(showWindow, () => {
  if (!showWindow.value) {
    selectedItem.value = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: getRouteName(),
              "show-secondary-trailing-btn": true,
              "secondary-trailing-icon": isExpandedAll() ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/create-post'))),
              onOnSecondaryBtnClick: _cache[1] || (_cache[1] = ($event: any) => (expandAll()))
            }, null, 8, ["title", "secondary-trailing-icon"])
          ]),
          _createVNode(_component_v_text_field, {
            class: "mt-5 search-bar",
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
            label: "Search",
            "prepend-inner-icon": "mdi-magnify",
            variant: "outlined",
            color: "primary",
            "clear-icon": "mdi-close",
            clearable: "",
            "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (searchText.value = ''))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (!isLoading.value && filteredList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" }),
                    _cache[6] || (_cache[6] = _createTextVNode(" " + _toDisplayString('No items found'), -1))
                  ]))
                : (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "4",
                          xl: "3",
                          xxl: "3",
                          class: "mt-5",
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_card, {
                                class: "rounded-xl",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-h4 font-weight-medium mt-2 rounded-xl item-title-container" }, {
                                    default: _withCtx(() => [
                                      (item.image !== '' && item.image !== undefined && item.image !== null)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 0,
                                            src: item.image,
                                            height: "40vh"
                                          }, null, 8, ["src"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.date), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.showContents)
                                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                                          _createVNode(_unref(QuillEditor), {
                                            class: "mt-2",
                                            content: item.contentsDelta,
                                            "onUpdate:content": ($event: any) => ((item.contentsDelta) = $event),
                                            options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                                          }, null, 8, ["content", "onUpdate:content"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        onClick: ($event: any) => (item.showContents = !item.showContents),
                                        variant: "text"
                                      }, {
                                        default: _withCtx(() => [
                                          (!item.showContents)
                                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                key: 0,
                                                icon: "fa-solid fa-chevron-down"
                                              }))
                                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                key: 1,
                                                icon: "fa-solid fa-chevron-up"
                                              }))
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        onClick: ($event: any) => {{
                        selectedItem.value = item;
                        showWindow.value = true;
                      }}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-window-maximize" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        href: item.image
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-up-right-from-square" })
                                        ]),
                                        _: 2
                                      }, 1032, ["href"]),
                                      (_unref(isSignedIn) && _unref(isAdmin))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            onClick: ($event: any) => (_unref(router).push({
                          name: 'modifyPost',
                          state: {
                            post: {
                              id: item.id,
                              contents: item.contents,
                              title: item.title,
                              date: item.date,
                              category: getRouteName()
                            }
                          }
                        }))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (_unref(isSignedIn) && _unref(isAdmin))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            color: "red",
                                            onClick: ($event: any) => (deleteItem(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
          ])
        ]),
        (showWindow.value && selectedItem.value !== null)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 0,
              modelValue: showWindow.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showWindow).value = $event)),
              style: { backdropFilter: 'blur(5px)' }
            }, {
              default: _withCtx(() => [
                _createVNode(BoardItemModal, {
                  "selected-item": selectedItem.value,
                  "is-signed-in": _unref(isSignedIn),
                  "is-admin": _unref(isAdmin),
                  "onOn:close": _cache[4] || (_cache[4] = ($event: any) => (showWindow.value = false)),
                  "onOn:update": onModifyItem,
                  "onOn:delete": deleteItem
                }, null, 8, ["selected-item", "is-signed-in", "is-admin"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})